export default '/pricing/extension-free-trial';
